import { validateNpmPackageName } from './lib/validateNpmPackageName';
export * from './lib/types';

export { validateNpmPackageName }

export default validateNpmPackageName
